import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { SessionService } from "../../../../@core/session/session.service";
import { Store } from "../../../../@core/store/store";
import { DynamicStackService } from "../service/dynamic-stack.service";
import { ForexPendingRequestsLoadingState, ForexPendingRequestsLoadedState, ForexPendingRequestsLoadingErrorState } from "../../../../@theme/components/header/service/header.state";
import { NbDialogService } from "@nebular/theme";
import { ForexMoreComponent } from "../forex-more/forex-more.component";

@Component({
  selector: 'ltts-forex',
  templateUrl: './forex.component.html',
  styleUrls: ['./forex.component.scss']
})
export class ForexComponent implements OnInit {
  forexHeading: string = "Forex Approval";
  forexData: any[] = [];
  forexLoadingData: boolean;
constructor(private dynamicStackService: DynamicStackService, private sessionService: SessionService, private cdRef: ChangeDetectorRef,private dialogService: NbDialogService ) { 
}

 @Input()
    set forexRequestsDataLoading(value) {
      this.forexLoadingData = value;
      //this.cdRef.detectChanges();
    }

   @Input()
    set forexReqForApprovalsData(value) {
      this.forexData = value;
      //this.cdRef.detectChanges();
    }
    
  ngOnInit(): void {
  }
  
redirectTo(url: string): void {
  if (url) {
    window.open(url, '_blank');
  }
}
viewMore(item: any) {
    this.dialogService
      .open(ForexMoreComponent, {
         context: {
        data: item
      },
      hasBackdrop: true,
      closeOnBackdropClick: true,

      })
      .onClose.subscribe((result) => {
    if (result === 'approved') {
      this.forexData = this.forexData.filter(emp => emp.forexId !== item.forexId);
       this.cdRef.detectChanges()
    }
  });

  }

}
